export default __webpack_public_path__ + "static/media/a018-7.6cbbd05f.svg";